// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__xjQPz","footer":"ModalUpdate_footer__M4EtX"};